import api from '../../../../../api/api'
import url from '../../../../../api/env'
import Utils from '../../../../../utils/Utils'

const getProductSubCategory = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api      
    .get(excludeChars ? `${url.stage.ProductSubCategory}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.countries}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const newProductSubCategory = async data =>
  api
    .post(url.stage.ProductSubCategory, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const editProductSubCategory = async (stateId, data) =>
  api
    .put(`${url.stage.ProductSubCategory}/${stateId}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const removeProductSubCategory = async stateId =>
  api
    .remove(`${url.stage.ProductSubCategory}/${stateId}`, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

export default {
  getProductSubCategory,
  newProductSubCategory,
  editProductSubCategory,
  removeProductSubCategory,
}
